import { Layout, Menu, Image, Row, Col } from 'antd';
import React, { useState } from 'react';
import { Outlet, useNavigate } from 'react-router-dom'

const { Header, Footer, Content } = Layout;

const MainOutlet = () => {
    const navigate = useNavigate();
    const [logo, setLogo] = useState(true);
    const [selecte_keys, setSelectedKeys] = useState([window.location.pathname]);
    const titles = {
        '/': '國語文經典表達力應用實驗計畫-首頁',
        '/video': '國語文經典表達力應用實驗計畫-活動影片',
        '/old': '國語文經典學習成效實驗計畫-首頁',
        '/old/poetry_reading': '國語文經典學習成效實驗計畫-詩詞朗讀',
        '/old/poetry_music_reading': '國語文經典學習成效實驗計畫-詩詞曲朗讀',
        '/old/ancient_chinese_reading': '國語文經典學習成效實驗計畫-古文朗讀',
        '/old/rhythm_enlightenment': '國語文經典學習成效實驗計畫-聲律啟蒙'
    }
    const onClick = e => {
        navigate(e.key)
        document.title = titles[e.key]
        setSelectedKeys([e.key])
        setLogo(['/', '/video'].includes(e.key) ? true : false)
    };
    const items = [
        {
            key: "/",
            label: `首頁`,
        },
        {
            key: "/video",
            label: `活動影片`,
        },
        {
            key: "/old",
            label: `歷史沿革`,
            children: [
                {
                    key: "/old",
                    label: `首頁`,
                },
                {
                    key: "/old/poetry_reading",
                    label: `詩詞朗讀`,
                },
                {
                    key: "/old/poetry_music_reading",
                    label: `詩詞曲朗讀`,
                },
                {
                    key: "/old/ancient_chinese_reading",
                    label: `古文朗讀`,
                },
                {
                    key: "/old/rhythm_enlightenment",
                    label: `聲律啟蒙`,
                },
            ]
        },
    ]
    return (
        <Layout className="layout" style={{ backgroundImage: `url(/background.png)`, backgroundRepeat: "repeat" }} >
            <Image preview={false} style={{ width: "100%" }} src={logo ? '/新網站首頁橫幅.jpg' : '/網站首頁橫幅.jpg'}></Image>

            <Header >
                <Row>
                    <Col  >
                        <div
                            style={{
                                width: "100%",
                                overflow: "hidden"
                            }}
                        >
                            <Menu onClick={onClick} selectedKeys={selecte_keys} mode="horizontal" items={items} style={{
                                borderRadius: '0px',
                                height: '64px',
                                border: '0px',
                                color: "#fff",
                                top: '0',
                                marginTop: '0',
                                padding: '0 20px',
                                borderColor: '#001529',
                                backgroundColor: "#001529",

                            }} />;
                        </div>
                    </Col>

                    <Col span={24}>
                        {/* <Menu
                            style={{ minWidth: 0, flex: "auto" }}
                            theme="dark"
                            mode="horizontal"
                            defaultSelectedKeys={['/']}
                            selectedKeys={selecte_keys}
                            onSelect={onSelect}
                            items={[
                                {
                                    key: "/",
                                    label: `首頁`,
                                },
                                {
                                    key: "/poetry_reading",
                                    label: `詩詞朗讀`,
                                },
                                {
                                    key: "/poetry_music_reading",
                                    label: `詩詞曲朗讀`,
                                },
                                {
                                    key: "/ancient_chinese_reading",
                                    label: `古文朗讀`,
                                },
                                {
                                    key: "/rhythm_enlightenment",
                                    label: `聲律啟蒙`,
                                },
                            ]}
                        /> */}
                    </Col>
                </Row>

            </Header >
            <Content
                style={{
                    // padding: '30px 50px',
                    padding: '4vw 4vw',
                    fontSize: "18px"
                }}
            >
                <Row>
                    <Col span={24}>
                        <Outlet />
                    </Col>
                </Row>
            </Content>
            <Footer
                style={{
                    textAlign: 'center',
                }}
            >
                Copyright ©2022 人工智慧研發產學中心
            </Footer>
        </Layout >
    )
};
export default MainOutlet;